<template>
  <div class="container align-center" style="margin-top: 100px; font-weight: 300;">

    <p style="font-size: 28px; font-family: 'Encode Sans', sans-serif;">Inactive</p>
    <p>This Brokerage Account on PFX platform is not yet activated.</p>
    <p>Please revisit the website later.</p>
  </div>

</template>

<script>
  export default {
    name: 'InactiveTenantPage',
    data() {
      return {
        role: this.$store.state.user.role || ''
      }
    },
    mounted() {
      if (this.role === 'ADMIN') {
        this.$router.push('/company/profile')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/InactiveTenantPage.vue